import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { Box } from '@mui/material';

const AuthDistributionChart = ({ data, loading = false, height = '220px' }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const chartDom = chartRef.current;
    if (!chartDom) return;

    // 清空並銷毀舊實例
    let chart = echarts.getInstanceByDom(chartDom);
    if (chart) {
      chart.dispose();
    }
    chartDom.innerHTML = '';

    chart = echarts.init(chartDom, null, { renderer: 'svg' });
    chartInstance.current = chart;

    if (loading || !data || data.length === 0) {
      return;
    }

    const option = {
      tooltip: { show: false },
      grid: { top: 10, left: 60, right: 40, bottom: 20 },
      xAxis: {
        type: 'value',
        minInterval: 1,
        axisLabel: { fontSize: 10, color: '#A0AEC0' },
        axisLine: { show: false },
        splitLine: { lineStyle: { type: 'dashed', color: '#E2E8F0' } }
      },
      yAxis: {
        type: 'category',
        data: data.map(item => item[0]),
        axisLabel: { fontSize: 10, color: '#A0AEC0' },
        axisLine: { show: false }, axisTick: { show: false },
        inverse: true
      },
      series: [
        {
          data: data.map(item => item[1]),
          type: 'bar',
          barWidth: '60%',
          itemStyle: { color: '#4C6EF5', borderRadius: [0, 0, 0, 0] },
          emphasis: {
            itemStyle: { color: '#172664' },
            label: {
              show: true,
              position: 'insideRight',
              distance: 8,
              formatter: '◀ P95: {c}s',
              color: '#FFFFFF',
              fontWeight: 'bold',
              fontSize: 11
            }
          },
          label: { show: false }
        }
      ]
    };

    chart.setOption(option);
    const handleResize = () => chart.resize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      chart.dispose();
    };
  }, [data, loading]);

  return (
    <Box sx={{ width: '100%', height, position: 'relative' }}>
      <Box
        ref={chartRef}
        sx={{
          width: '100%', height: '100%',
          opacity: loading ? 0 : 1,
          transition: 'opacity 0.3s'
        }}
      />
    </Box>
  );
};

export default AuthDistributionChart;